module.exports = __webpack_public_path__ + "img/money-euro-box-line.04034f6f.svg";